// extracted by mini-css-extract-plugin
module.exports = {"containerBanner":"InformativeBanner_containerBanner__1ZHOX","fadeIn":"InformativeBanner_fadeIn__3MVzz","containerWarning":"InformativeBanner_containerWarning__1sLNn"};